import { render, staticRenderFns } from "./salesCoreIndicators.vue?vue&type=template&id=5f841ca0&scoped=true"
import script from "./salesCoreIndicators.vue?vue&type=script&lang=js"
export * from "./salesCoreIndicators.vue?vue&type=script&lang=js"
import style0 from "./salesCoreIndicators.vue?vue&type=style&index=0&id=5f841ca0&prod&lang=scss&scoped=true"
import style1 from "./salesCoreIndicators.vue?vue&type=style&index=1&id=5f841ca0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f841ca0",
  null
  
)

export default component.exports